/**
 *
 * @module subscriptionStatusType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionStatusType
 * @type {Object}
 *
 * @property {String} SUBSCRIBED
 * @property {String} UNSUBSCRIBED
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionStatusType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    SUBSCRIBED: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    UNSUBSCRIBED: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionStatusType.js